import React from "react";
import * as S from "./styles";
export var InfoV2 = function InfoV2(e) {
  return React.createElement(S.BaseSVG, Object.assign({
    width: "16",
    height: "17",
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e), React.createElement("path", {
    d: "M8 15L8 7",
    stroke: "#006298",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("circle", {
    cx: "8",
    cy: "1.5",
    r: "1.5",
    transform: "rotate(-180 8 1.5)",
    fill: "#006298"
  }));
};